module.exports = __webpack_public_path__ + "static/media/book-alt.d3220137.svg";